import api from './AxiosInstance';

export class JournauxComptableService {
  getAllJournauxComptable = async () => {
    try {
      const response = await api.get(`/SaisieJournal/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };


  addJournal = async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/SaisieJournal/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updateJournal= async ( updatedPrestation) => {
    try {
     

      const response = await api.put(`/SaisieJournal/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteJournal= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/SaisieJournal/delete/${prestationId}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}


